import React, { useEffect } from 'react'
import { IonPage, IonHeader, IonContent } from '@ionic/react'
import { observer } from 'mobx-react'
import { advertMobx, themeMobx } from '@mobxStore'
import { useHistoryNew, getPlatform, miniAppRouteTo } from '@utils'
import './index.scss'
interface IProps {

}

const WeChatWork: React.FC<IProps> = props => {
  const { } = props
  const history = useHistoryNew()
  const { adDetail, advertInfo, advertInit } = advertMobx
  const { weChatWork } = adDetail
  const type = history.location.pathname.split('/')[2] as TAdvertCaseType
  const { isWeixin, isWeixinMiniProgram, isAliPayMiniProgram } = getPlatform()

  useEffect(() => {
    if (type && !advertInit) {
      const ad = advertInfo[type]?.ads?.filter(ad => ad.type === 'weChatWork')?.[0]
      advertMobx.pick(ad, type)
    }
  }, [type])

  const goBack = () => {
    const prevState = history.getPrevState()
    if (prevState) {
      history.push(prevState)
    } else {
      const hasHome = themeMobx?.showTabs?.find(item => item.type === 'home')
      if (hasHome && hasHome.isShow !== 0) {
        if (isWeixinMiniProgram) {
          miniAppRouteTo({
            url: '/pages/home/index'
          })
        } else if (isAliPayMiniProgram) {
          miniAppRouteTo({
            url: '/pages/home/index'
          })
        } else {
          history.push('/home')
        }
      } else {
        history.push('/menu')
      }
    }
  }
  return (
    <IonPage className='wechat-page'>
      <IonHeader
        className='navigator'
      >
        <div className='left'>
          <div className='left-back' onClick={goBack}>
            <i className='iconfont icon-BACK-12x'></i>
          </div>
        </div>
        <div className='title'>{i18n.t('advert.weChatWork')}</div>
        <div className='right'>
          {/* {extra} */}
        </div>
      </IonHeader>
      <IonContent>
        <div className='content' style={{ backgroundImage: `url(${weChatWork?.bgUrl || ''})` }}>
          {/* <img src={weChatWork?.bgUrl} alt='' /> */}
          <div className='txt'>
            {
              weChatWork?.subtitle && <p className='subtitle'>{weChatWork?.subtitle}</p>
            }
            {
              weChatWork?.title && <p className='title'>{weChatWork?.title}</p>
            }
          </div>
          {
            weChatWork?.cordUrl && <img src={weChatWork?.cordUrl} alt='' className='qrcode' />
          }
        </div>
      </IonContent>
    </IonPage>
  )
}

export default observer(WeChatWork)
